class MyReportController extends AbstractController
	@register()
	@inject '$stateParams',
		'ReportService'
		'QueueTaskRepository'
		'BACKEND_QUEUE_TASK_STATUS'
		'BACKEND_REPORT_TYPE'

	initialize: ->
		@reports = []
		@datepickerConfig =
			enableClear: true
			maxDate: moment().endOf('day')

		@filter =
			page_size: @QueueTaskRepository.pageSize
			count: 0
			page: 1
			status: null
			report_type: null
			from: null
			to: null
			from_create_time: null
			to_create_time: null
			register_id: null

		if @$stateParams.report_type && _.values(@BACKEND_REPORT_TYPE).includes(@$stateParams.report_type)
			@filter.report_type = @$stateParams.report_type

		@setFilters()
		@search(1, true)

	setFilters: ->
		@statuses = {}
		@reportTypes = {}

		excludedReports = [
			@BACKEND_REPORT_TYPE.WEEKCOVER,
			@BACKEND_REPORT_TYPE.PROMOTIONS,
			@BACKEND_REPORT_TYPE.CATEGORY_SALES,
			@BACKEND_REPORT_TYPE.GIFTCARDS,
			@BACKEND_REPORT_TYPE.VOUCHER_TYPES,
			@BACKEND_REPORT_TYPE.TURNOVER,
			@BACKEND_REPORT_TYPE.TENDER_TYPE_SALES,
			@BACKEND_REPORT_TYPE.INVENTORY_NOT_COUNTED_PRODUCTS,
		]

		for statusKey, status of @BACKEND_QUEUE_TASK_STATUS
			@statuses[status] = 'general.report.status.' + status

		for typeKey, type of @BACKEND_REPORT_TYPE
			if !excludedReports.includes(type)
				@reportTypes[type] = 'general.report.type.' + type

	search: (page = 1, withCounts = false) ->
		@filter.page = page

		@ReportService
			.search @filter, withCounts
			.then (entities) =>
				@reports = entities

	download: (file) ->
		@ReportService.download(file)

	onPageSizeChange: (pageSize) ->
		@filter.page_size = pageSize

		@search()
